// extracted by mini-css-extract-plugin
export default {"motivationWrapper":"MotivationExercise_motivationWrapper__LZ9Th"};